import { render } from "./BaseRenderScene.vue?vue&type=template&id=16fd2e58"
import script from "./BaseRenderScene.vue?vue&type=script&lang=js"
export * from "./BaseRenderScene.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__